import useWeakMap from "../../../utils/useWeakMap";
import { ATTRIBUTE_PREFIX_BIND_ATTR, ATTRIBUTE_PREFIX_BIND_ATTR_SHORT } from "../../enum";
import { runExtractValue } from "../../executor";
import { convertToPropAccessByBracket, extractContentByTag, isStringContainChar } from "../../util";
import { canBindingNode } from "../useBinding";
import useWatcher from "../useWatcher";

const caching = useWeakMap();

const render = (node, props, attr) => {
    const { attrName, attrValue } = attr;
    if (isStringContainChar(attrValue, '{', '}')) throw `${attrValue} is invalid. Bind Attribute does not allow "{" or "}"`;
    /* In some case, need remove attribute first to avoid caching. 
     * Like an image when change url, it still using old src, it only render when image loaded */
    node.removeAttribute(attrName);
    node.setAttribute(attrName, runExtractValue(props, attrValue))
}

/**
* @param {{ attrName: string, attrValue: string }} attr
* @param {object} props
* @param {Node} node
*/
const useBindAttr = (attr, props, node) => {

    if (!caching.has(node)) {
        caching.set(node, []);
    }

    attr.attrName = attr.attrName
        .replace(ATTRIBUTE_PREFIX_BIND_ATTR, '')
        .replace(ATTRIBUTE_PREFIX_BIND_ATTR_SHORT, '');

    const { onPropChanges, onCreated, onDestroy } = useWatcher(props, node, [attr.attrValue]);


    onDestroy(() => {
        caching.delete(node);
    })

    onPropChanges((p, key) => {
        render(node, props, attr)
    });

    return Promise.resolve();
}

export default useBindAttr;